import React from 'react';
import { Space } from 'antd';
import classNames from 'classnames';
import { useGetFavorites } from 'api/favorites/use-get-favorites';
import { favoriteColorMapping } from 'types/favorites';
import { ColorsDropdown } from 'components/favorites/colors-dropdown';
import { FavoriteColorCircle } from 'components/favorites/favorite-color-circle';
import styles from './color-circles.module.scss';
import type { IColorCirclesProps } from './types';

export const ColorCircles: React.FC<IColorCirclesProps> = (props) => {
  const { cargoId, grayCircleClassnames } = props;

  const { data: favoriteData } = useGetFavorites();

  if (!favoriteData) return null;

  const favoriteColors = favoriteData.favoriteRecords?.[cargoId] || [];
  const grayDotClasses = classNames(styles.grayDot, grayCircleClassnames);

  return (
    <ColorsDropdown cargoIds={[cargoId]} markedColors={favoriteColors}>
      <Space align='center' className={styles.colorCirclesContainer}>
        {favoriteColors.length > 0 ? (
          favoriteColors.map((color, index) => (
            <FavoriteColorCircle
              key={color}
              diameter={15}
              backgroundColor={favoriteColorMapping[color]}
              style={{
                marginLeft: index === 0 ? 0 : '-12px',
                border: '2px solid white',
              }}
            />
          ))
        ) : (
          <div className={grayDotClasses} />
        )}
      </Space>
    </ColorsDropdown>
  );
};
